import React, { Component } from "react";
import gql from "graphql-tag";

import { Query } from "react-apollo";
import { connect } from "react-redux";
import { Box } from "reflexbox";
import _ from "lodash";

import { List } from "office-ui-fabric-react/lib/List";
import ShipmentCard from "./_ShipmentCard";

import ToggleForm from "../../common/Buttons/_ToggleForm";

import ShipmentDeleteButton from "../../common/Buttons/_ShipmentDeleteButton";

import ToggleShipmentAttachmentDialog from "../../common/Buttons/_ToggleShipmentAttachmentDialog";

import { CommandBar } from "office-ui-fabric-react/lib/CommandBar";

class ShipmentsList extends Component {
  _onRenderItem = item => {
    return <div key={item.key}>{item.component} </div>;
  };

  render() {
    const { shipment, items } = this.props;

    return (
      <Box>
        <Box mt={1}>
          <CommandBar
            isSearchBoxVisible={false}
            items={[
              {
                onRender: this._onRenderItem,
                component: <ToggleForm form="shipment" addOrEdit="add" />,
                key: "item1"
              },
              {
                onRender: this._onRenderItem,
                component: (
                  <ToggleForm
                    form="shipment"
                    addOrEdit="edit"
                    disabled={_.isEmpty(this.props.shipment)}
                  />
                ),
                key: "item2"
              },
              {
                onRender: this._onRenderItem,
                component: (
                  <ToggleShipmentAttachmentDialog buttonType="command" />
                ),
                key: "item3"
              },
              {
                onRender: this._onRenderItem,
                component: <ShipmentDeleteButton items={[shipment]} />,
                key: "item4"
              }
            ]}
          />
        </Box>
        <Box>
          <div className="list-container" data-is-scrollable="true">
            <List
              items={items}
              usePageCache={true}
              onRenderCell={(item, index) => {
                return (
                  <div data-is-focusable={true}>
                    <ShipmentCard item={item} />
                  </div>
                );
              }}
            />
          </div>
        </Box>
      </Box>
    );
  }
}

class ShipmentsListContainer extends Component {
  render() {
    const { shipment } = this.props;

    return (
      <Query
        query={GET_SHIPMENTS}
        variables={{
          archived: this.props.isArchivedShipmentsVisible
        }}
        // pollInterval={25000}
      >
        {({ loading, error, data }) => {
          if (loading) return <p>Loading...</p>;
          if (error) return <p>Error :(</p>;

          let items = _.orderBy(
            data.allShipments.nodes,
            [
              "relationByRelationId.name",
              "date",
              "cargoTypeByCargoTypeId.type"
            ],
            ["asc", "desc", "asc"]
          );
          return <ShipmentsList items={items} shipment={shipment} />;
        }}
      </Query>
    );
  }
}

const GET_SHIPMENTS = gql`
  query allShipments($archived: Boolean) {
    allShipments(condition: { archived: $archived }) {
      nodes {
        id
        selected
        date
        about
        status
        archived
        carrierId
        relationId
        cargoTypeId
        createdAt
        updatedAt
        storagesByShipmentId {
          nodes {
            id
            fileName
            fileSize
            fileType
            url
          }
        }
        carrierByCarrierId {
          id
          truck
          trailer
          driver1Tel
          driver2Tel
          type
          emptyWeight
          trolleysSection1
          trolleysSection2
          about
        }
        relationByRelationId {
          id
          name
          color
        }
        cargoTypeByCargoTypeId {
          id
          type
          code
        }
      }
    }
  }
`;

const mapStateToProps = state => {
  return {
    isArchivedShipmentsVisible: state.ui.isArchivedShipmentsVisible,
    shipment: state.selected.shipment
  };
};

export default connect(mapStateToProps)(ShipmentsListContainer);



// WEBPACK FOOTER //
// ./src/views/Shipments/_ShipmentsList.js